// AI Model Configs (provider/model definitions for investigation + gate roles) — React Admin
// resource strings (sub-plan 20). Wired to /api/backend/ai-troubleshooting/model-configs.
export const aiModelConfigs = {
  name: 'AI Model Configs',
  fields: {
    id: 'ID',
    provider: 'Provider',
    modelName: 'Model Name',
    displayName: 'Display Name',
    gatewayRoute: 'Gateway Route',
    role: 'Role',
    isActive: 'Active',
    isDefault: 'Default',
    default: 'Default',
    params: 'Params (JSON)',
    createdAt: 'Created',
    updatedAt: 'Updated',
  },
  sections: {
    identity: 'Identity',
    behaviour: 'Behaviour',
    params: 'Parameters',
  },
  roles: {
    investigation: 'Investigation',
    gate: 'Gate',
  },
  filters: {
    role: 'Role',
    isActive: 'Status',
    active: 'Active',
    inactive: 'Inactive',
  },
  actions: {
    setDefault: 'Set as default',
  },
  list: {
    title: 'AI Model Configs',
  },
  create: {
    title: 'Create Model Config',
    subtitle: 'Add an AI model configuration',
    backToList: 'Back to model configs',
  },
  edit: {
    title: 'Edit Model Config',
    subtitle: 'Refine this AI model configuration',
    backToList: 'Back to model configs',
  },
  helpers: {
    modelName: 'The provider model id (e.g. glm-4-plus, qwen-max).',
    displayName: 'Human label shown in the replay picker.',
    gatewayRoute: 'Optional AI Gateway path/base endpoint. Leave empty for the default.',
    isActive: 'Inactive configs are hidden from the replay picker but still listed here.',
    isDefault: 'At most one default per role.',
    defaultWarning:
      'Only one default model is allowed per role; saving this will replace any existing default for the selected role.',
    params: 'JSON object of model params (temperature, max_tokens, ...).',
  },
  errors: {
    invalidJson: 'Invalid JSON. Please fix the syntax before saving.',
    paramsNotObject: 'Params must be a JSON object (e.g. { "temperature": 0.2 }).',
    conflict:
      'A model config with this provider + model + role already exists, or a default conflict occurred. Please review and try again.',
    inUse: 'This model is the default for its role; set another default first.',
    defaultConflict:
      'Could not set this model as default due to a conflict. Refresh and try again.',
    defaultFailed: 'Could not set this model as default.',
  },
  notifications: {
    created: 'Model config created successfully.',
    updated: 'Model config updated successfully.',
    deleted: 'Model config deleted successfully.',
    defaultSet: 'Default model updated.',
    error: {
      create: 'Failed to create model config.',
      update: 'Failed to update model config.',
      delete: 'Failed to delete model config.',
    },
  },
};
